import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Tools from "./pages/Tools";
import Rams from "./pages/Rams";
import Risk from "./pages/Risk";
import Method from "./pages/Method";
import Support from "./pages/Support";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <>
      <Header />
      <div style={{ maxWidth: 980, margin: "0 auto" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/rams" element={<Rams />} />
          <Route path="/risk" element={<Risk />} />
          <Route path="/method" element={<Method />} />
          <Route path="/support" element={<Support />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
}